import React from "react";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/sagas/utilization";
import { useSelector, useDispatch } from "react-redux";
import { useDateFormat } from "../../../hooks/useDateFormat";

export const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();
  const { startDate, endDate } = useSelector((state) => state.utilization.selectedRequestDates);
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.utilization.currentUser
  );
  const maxDate = useSelector((state) => state.utilization.maxDate);
  const future_bookings = useSelector((state) => state.utilization.future_bookings);
  const minDate = useSelector((state) => state.utilization.minDate);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      minDate={future_bookings ? minDate : calendarStartDate}
      calendarEndDate={future_bookings ? maxDate : calendarEndDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate: startDate, endDate: endDate }))
      }
    />
  );
};
